import { RouterState } from "mobx-state-router";
// Routes are matched from top to bottom. Make sure they are sequenced
// in the order of priority. It is generally best to sort them by pattern,
// prioritizing specific patterns over generic patterns (patterns with
// one or more parameters). For example:
//     /items
//     /items/:id
const checkForUserSignedIn = (fromState, toState, routerStore) => {
	const {
		rootStore: { userStore }
	} = routerStore;
	// console.log("State is", toState);
	if (userStore.currentUser.name != null) {
		return Promise.resolve();
	} else {
		userStore.setSignInRedirect(toState);
		return Promise.reject(new RouterState("login"));
	}
};

export const routes = [
	{
		name: "acProject",
		pattern: "/acproject/:id",
		title: "Account Creation Project",		
		beforeEnter: checkForUserSignedIn,
		onEnter: (fromState, toState, routerStore) => {			
			const {
				rootStore: { acProjectStore }
			} = routerStore;
			const projectId = toState.params.id;
			acProjectStore.fetchProject(projectId);
			return Promise.resolve();
		}
	},
	{
		name: "postingProject",
		pattern: "/project/:id",
		title: "Posting Project",
		beforeEnter: checkForUserSignedIn,
		onEnter: (fromState, toState, routerStore) => {
			const {
				rootStore: { projectStore }
			} = routerStore;
			const projectId = toState.params.id;
			projectStore.fetchProject(projectId);
			return Promise.resolve();
		}
	},
	{
		name: "indexerProject",
		pattern: "/indexerproject/:id",
		title: "Indexer Project",
		beforeEnter: checkForUserSignedIn,
		onEnter: (fromState, toState, routerStore) => {
			const {
				rootStore: { indexerProjectStore }
			} = routerStore;
			const projectId = toState.params.id;
			indexerProjectStore.fetchProject(projectId);
			return Promise.resolve();
		}
	},
	{
		name: "privateProject",
		pattern: "/privateproject/:id",
		title: "Private Blog Project",
		beforeEnter: checkForUserSignedIn,
		onEnter: (fromState, toState, routerStore) => {
			const {
				rootStore: { privateProjectStore }
			} = routerStore;
			const projectId = toState.params.id;
			privateProjectStore.fetchProject(projectId);
			return Promise.resolve();
		}
	},
	{
		name: "home",
		pattern: "/",
		title: "Home",
		beforeEnter: checkForUserSignedIn,
		onEnter: (fromState, toString, routerStore) => {
			return Promise.reject(new RouterState("campaigns"))
		}
	},
	{
		name: "campaigns",
		pattern: "/campaigns",
		title: "Campaigns",
		beforeEnter: checkForUserSignedIn,
		onEnter: (fromState, toState, routerStore) => {
			const {
				rootStore: { campaignsStore }
			} = routerStore;

			campaignsStore.loadCampaigns();
			return Promise.resolve();
		}
	},
	{
		name: "xwizards",
		pattern: "/xwizards",
		title: "XWizards",
		beforeEnter: checkForUserSignedIn,
		onEnter: (fromState, toState, routerStore) => {
			const {
				rootStore: { xwizardsStore }
			} = routerStore;

			xwizardsStore.loadWizards();
			return Promise.resolve();
		}
	},	
	{
		name: "campaign",
		pattern: "/campaign/:id",
		title: "Campaign",
		beforeEnter: checkForUserSignedIn,
		onEnter: (fromState, toState, routerStore) => {
			const {
				rootStore: { campaignStore }
			} = routerStore;

			const campaignId = toState.params.id;

			campaignStore.fetchCampaign(campaignId);
			return Promise.resolve();
		}
	},
	{
		name: "article",
		pattern: "/article/:id",
		title: "Article",
		beforeEnter: checkForUserSignedIn,
		onEnter: (fromState, toState, routerStore) => {
			const {
				rootStore: { articleStore }
			} = routerStore;

			const articleId = toState.params.id;

			articleStore.loadArticle(articleId);
			return Promise.resolve();
		}
	},
	{
		name: "newArticle",
		pattern: "/new-article/:id",
		title: "New Article",
		beforeEnter: checkForUserSignedIn,
		onEnter: (fromState, toState, routerStore) => {
			const {
				rootStore: { articleStore }
			} = routerStore;
			const contentGroupId = toState.params.id;

			articleStore.initArticle(contentGroupId);
			return Promise.resolve();
		}
	},
	{
		name: "privateNetworks",
		pattern: "/private-networks",
		title: "Private Networks",
		beforeEnter: checkForUserSignedIn,
		onEnter: (fromState, toState, routerStore) => {
			const {
				rootStore: { privateNetworksStore }
			} = routerStore;

			privateNetworksStore.loadPrivateNetworks();
			return Promise.resolve();
		}
	},	
	{
		name: "privateNetwork",
		pattern: "/private-network/:id",
		title: "Private Networks",
		beforeEnter: checkForUserSignedIn,
		onEnter: (fromState, toState, routerStore) => {
			const {
				rootStore: { privateNetworkStore }
			} = routerStore;

			const privateNetworkId = toState.params.id;

			privateNetworkStore.loadPrivateNetwork(privateNetworkId);
			return Promise.resolve();
		}
	},	
	{
		name: "contentGroups",
		pattern: "/content-groups",
		title: "Content Groups",
		beforeEnter: checkForUserSignedIn,
		onEnter: (fromState, toState, routerStore) => {
			const {
				rootStore: { contentGroupsStore }
			} = routerStore;

			contentGroupsStore.loadContentGroups();
			return Promise.resolve();
		}
	},
	{
		name: "contentGroup",
		pattern: "/content-group/:id",
		title: "Content Group",
		beforeEnter: checkForUserSignedIn,
		onEnter: (fromState, toState, routerStore) => {
			const {
				rootStore: { contentGroupStore }
			} = routerStore;

			const contentGroupId = toState.params.id;
			contentGroupStore.loadContentGroup(contentGroupId);
			return Promise.resolve();
		}
	},
	{
		name: "accounts",
		pattern: "/accounts/:id",
		title: "Accounts",
		beforeEnter: checkForUserSignedIn,
		onEnter: (fromState, toState, routerStore) => {
			const {
				rootStore: { accountsStore, uiStore }
			} = routerStore;

			const accountProfileId = toState.params.id;

			accountsStore.fetchAccounts(accountProfileId);
			uiStore.fetchSites();
			return Promise.resolve();
		}
	},
	{
		name: "links",
		pattern: "/url_list/:id",
		title: "Links",
		beforeEnter: checkForUserSignedIn,
		onEnter: (fromState, toState, routerStore) => {
			const {
				rootStore: { linksStore }
			} = routerStore;

			const urlListId = toState.params.id;

			linksStore.fetchLinks(urlListId);
			return Promise.resolve();
		}
	},
	{
		name: "notFound",
		pattern: "not-found"
	},
	{
		name: "options",
		pattern: "/options",
		title: "Options",
		beforeEnter: checkForUserSignedIn,
		onEnter: (fromState, toState, routerStore) => {
			const {
				rootStore: { optionsStore }
			} = routerStore;
			const tab = toState.queryParams.tab;
			optionsStore.loadOptions({
				tab: tab
			});
			return Promise.resolve();
		}
	},
	{
		name: "login",
		pattern: "/user/login",
		title: "Login"
	},
	{
		name: "newcampaign",
		pattern: "/newcampaign/:sid",
		title: "Wizard",
		beforeEnter: checkForUserSignedIn,
		onEnter: (fromState, toState, routerStore) => {
			const {
				rootStore: { xwizardStore }
			} = routerStore;

			const strategyId = toState.params.sid;
			const campaignName = toState.queryParams.campaignName;
			xwizardStore.initCampaign({
				strategyId: strategyId, 
				campaignName: campaignName, 
				//TODO: wizardId: 0
				wizardId: null
			});
			return Promise.resolve();
		}
	},
	{
		name: "newWizard",
		pattern: "/newwizard/:sid",
		title: "Wizard",
		beforeEnter: checkForUserSignedIn,
		onEnter: (fromState, toState, routerStore) => {
			const {
				rootStore: { xwizardStore }
			} = routerStore;

			const strategyId = toState.params.sid;
			const campaignName = toState.queryParams.campaignName;
			const wizardName = toState.queryParams.wizardName;
			xwizardStore.initCampaign({
				strategyId: strategyId, 
				campaignName: campaignName, 
				wizardName: wizardName,
				//TODO wizardId: 0
				wizardId: null
			});
			return Promise.resolve();
		}
	},		
	{
		name: "duplicatecampaign",
		pattern: "/duplicatecampaign/:cid",
		title: "Wizard",
		beforeEnter: checkForUserSignedIn,
		onEnter: (fromState, toState, routerStore) => {
			const {
				rootStore: { xwizardStore }
			} = routerStore;

			const campaignId = toState.params.cid;
			const campaignName = toState.queryParams.campaignName;
			const useSameAccounts = toState.queryParams.useSameAccounts === 'true';

			xwizardStore.duplicateCampaign(campaignId, campaignName, useSameAccounts);
			return Promise.resolve();
		}
	},	
	{
		name: "emailManager",
		pattern: "/email-manager",
		title: "Email Manager",
		beforeEnter: checkForUserSignedIn,
		onEnter: (fromState, toState, routerStore) => {
			const {
				rootStore: { emailStore }
			} = routerStore;

			emailStore.loadEmails();
			return Promise.resolve();
		}
	},
	{
		name: "cloudAccounts",
		pattern: "/cloud-accounts",
		title: "Cloud Account",
		beforeEnter: checkForUserSignedIn,
		onEnter: (fromState, toState, routerStore) => {
			const {
				rootStore: { cloudAccountsStore }
			} = routerStore;

			cloudAccountsStore.loadAccounts();
			return Promise.resolve();
		}
	},
	{
		name: "cloudBlogGenerator",
		pattern: "/cloud-blog-generator",
		title: "Cloud Blog Generator",
		beforeEnter: checkForUserSignedIn,
		onEnter: (fromState, toState, routerStore) => {						
			return Promise.resolve();
		}
	},
	{
		name: "xwizard",
		pattern: "/xwizard/:id",
		title: "Wizard",
		beforeEnter: checkForUserSignedIn,
		onEnter: (fromState, toState, routerStore) => {
			const {
				rootStore: { xwizardStore }
			} = routerStore;
			const wizardId = toState.params.id;			
			xwizardStore.initWizard(wizardId);
			return Promise.resolve();
		}
	},
	{
		name: "strategies",
		pattern: "/strategies",
		title: "Diagrams",
		beforeEnter: checkForUserSignedIn,
		onEnter: (fromState, toState, routerStore) => {
			const {
				rootStore: { strategiesStore }
			} = routerStore;
			strategiesStore.loadStrategies();
			return Promise.resolve();
		}
	},
	{
		name: "strategy",
		pattern: "/strategy/:id",
		title: "Strategy Designer",
		beforeEnter: checkForUserSignedIn,
		onEnter: (fromState, toState, routerStore) => {
			const {
				rootStore: { strategyStore }
			} = routerStore;

			const strategyId = toState.params.id;
			strategyStore.loadStrategy(strategyId);
			return Promise.resolve();
		},
		onExit: (fromState, toState, routerStore) => {
			// console.log(fromState);
			// console.log(toState);
			// console.log(routerStore);
		}
	},
	{
		name: "siteSelections",
		pattern: "/site-selections",
		title: "Site Selections",
		beforeEnter: checkForUserSignedIn,
		onEnter: (fromState, toState, routerStore) => {
			const {
				rootStore: { siteSelectionsStore }
			} = routerStore;

			siteSelectionsStore.loadSiteSelections();
			return Promise.resolve();
		}
	},
	{
		name: "siteSelection",
		pattern: "/site-selection/:id",
		title: "Site Selection",
		beforeEnter: checkForUserSignedIn,
		onEnter: (fromState, toState, routerStore) => {
			const {
				rootStore: { siteSelectionStore }
			} = routerStore;

			const siteSelectionId = toState.params.id;
			siteSelectionStore.loadSiteSelection(siteSelectionId);
			return Promise.resolve();
		}
	},
	{
		name: "customSites",
		pattern: "/custom-sites",
		title: "Custom Sites",
		beforeEnter: checkForUserSignedIn,
		onEnter: (fromState, toState, routerStore) => {
			const {
				rootStore: { customSitesStore }
			} = routerStore;

			customSitesStore.loadCustomSites();
			return Promise.resolve();
		}
	},	
];
